import { render, staticRenderFns } from "./PgaInputFile.vue?vue&type=template&id=db433c3c&"
import script from "./PgaInputFile.vue?vue&type=script&lang=ts&"
export * from "./PgaInputFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db433c3c')) {
      api.createRecord('db433c3c', component.options)
    } else {
      api.reload('db433c3c', component.options)
    }
    module.hot.accept("./PgaInputFile.vue?vue&type=template&id=db433c3c&", function () {
      api.rerender('db433c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/PgaInputFile.vue"
export default component.exports